import React, { useState } from 'react';
import axios from 'axios';
import CustomSelect from '../widgets/CustomSelect';
import {
  CASH_REGISTER_EMPLOYEE_ENDPOINT,
  SECURITY_CODE_PATTERN,
} from './cashRegisterConfig';
import '../../styles/CashRegister.css';

const OpenRegisterModal = ({ branch, onClose, onSuccess }) => {
  const [openingBalance, setOpeningBalance] = useState('');
  const [employeeId, setEmployeeId] = useState(null);
  const [securityCode, setSecurityCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const balance = parseFloat(openingBalance);
    if (isNaN(balance) || balance < 0) {
      setError('Please enter a valid opening cash amount.');
      return;
    }
    if (!employeeId) {
      setError('Please select your name to sign.');
      return;
    }
    if (!SECURITY_CODE_PATTERN.test(securityCode)) {
      setError('Employee access code must be 4 to 8 letters or numbers.');
      return;
    }

    try {
      setSubmitting(true);
      await axios.post(
        `${process.env.REACT_APP_SERVER_BASE_URL}/hospital-portal/api/cash-register/open`,
        {
          branch,
          opening_balance: balance,
          opened_by_employee_id: employeeId,
          security_code: securityCode,
        }
      );
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to open register. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="cash-register-modal">
        <div className="modal-header">
          <h2>Open Register — {branch}</h2>
          <button className="modal-close" onClick={onClose} type="button">×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && <div className="cash-register-error">{error}</div>}
            <p className="instruction-text">
              Count the cash in the register and enter the amount below. Select your name and enter your personal access code to sign.
            </p>
            <div className="form-field">
              <label htmlFor="opening-balance">Opening cash amount *</label>
              <input
                id="opening-balance"
                type="number"
                min="0"
                step="0.01"
                value={openingBalance}
                onChange={(e) => setOpeningBalance(e.target.value)}
                placeholder="0.00"
                required
              />
            </div>
            <div className="form-field">
              <label>Your name (signature) *</label>
              <CustomSelect
                name="opened_by_employee_id"
                value={employeeId}
                onChange={(name, value) => setEmployeeId(value)}
                endpoint={CASH_REGISTER_EMPLOYEE_ENDPOINT}
                valueField="employee_id"
                labelField="employee_name"
                placeholder="Search employee..."
                isSearchable={true}
              />
            </div>
            <div className="form-field">
              <label htmlFor="open-security-code">Employee access code *</label>
              <input
                id="open-security-code"
                type="password"
                className="access-code-input"
                value={securityCode}
                onChange={(e) => setSecurityCode(e.target.value)}
                maxLength={8}
                autoComplete="off"
                placeholder="Enter your access code"
                required
              />
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn-secondary" type="button" onClick={onClose} disabled={submitting}>
              Cancel
            </button>
            <button
              className="btn-primary"
              type="submit"
              disabled={submitting || !employeeId || !SECURITY_CODE_PATTERN.test(securityCode)}
            >
              {submitting ? 'Opening...' : 'Open Register'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OpenRegisterModal;
